const initialState = {
  sortedSlicedData: [],
  searchedWord: null,
  keyword: false,
  filteredEmployeeData: [],
  employeesData: [
    {
      id: 0,
      name: "siddhi",
      surname: "Nandaniya",
      email: "siddhinandiya2811@gmail.com",
      salary: 20000,
      phone: 65823859,
    },
    {
      id: 1,
      name: "Yash",
      surname: "patel",
      email: "yashpatel@gmail.com",
      salary: 10000,
      phone: 366838764,
    },
    {
      id: 2,
      name: "riddhi",
      surname: "parmar",
      email: "riddhiparmar@gmail.com",
      salary: 50000,
      phone: 74894444,
    },
    {
      id: 3,
      name: "zac",
      surname: "kin",
      email: "zackin@gmail.com",
      salary: 70000,
      phone: 47583434,
    },
    {
      id: 4,
      name: "sia",
      surname: "malhotra",
      email: "siamalhotra@gmail.com",
      salary: 80000,
      phone: 25245242,
    },
    {
      id: 5,
      name: "pooja",
      surname: "desai",
      email: "poojadesai@gmail.com",
      salary: 90000,
      phone: 423428578,
    },
    {
      id: 6,
      name: "krupali",
      surname: "patel",
      email: "krupalipatel@gmail.com",
      salary: 80000,
      phone: 848122525,
    },
    {
      id: 7,
      name: "miral",
      surname: "thummar",
      email: "miralthummar@gmail.com",
      salary: 60000,
      phone: 45363464,
    },
  ],
};
const taskReducer = (state = initialState, action) => {
  switch (action.type) {
    case "ADD_Employee_Record":
      return {
        ...state,
        employeesData: [action.payload, ...state.employeesData],
        keyword: false,
        searchedWord: null,
      };

    case "DELETE_Employee_Record":
      return {
        ...state,
        employeesData: [
          ...state.employeesData.filter((e) => e.id !== action.payload),
        ],
        filteredEmployeeData: [
          ...state.employeesData.filter((e) => e.id !== action.payload),
        ],
      };
    case "REMOVE_searched_word":
      return {
        ...state,
        searchedWord: null,
      };

    case "UPDATE_Employee_Record":
      console.log(action.payload.empid, action.payload.inputRecord, "#######");
      return {
        ...state,
        searchedWord: null,
        keyword: false,
        employeesData: [
          ...state.employeesData.map((emp) => {
            if (Number(action.payload.empid) === emp.id) {
              return action.payload.inputRecord;
            }
            return emp;
          }),
        ],
      };
    case "SORT_Asc_Employee_Record":
      return {
        ...state,
        // keyword: false,
        searchedWord: null,
        employeesData: [
          ...state.employeesData.sort((a, b) => {
            let fa = a.name.toLowerCase(),
              fb = b.name.toLowerCase();
            if (fa < fb) {
              return -1;
            }
            if (fa > fb) {
              return 1;
            }
            return 0;
          }),
        ],
      };
    case "SORT_Des_Employee_Record":
      return {
        ...state,
        // keyword: false,
        searchedWord: null,
        employeesData: [
          ...state.employeesData.sort((a, b) => {
            let fa = a.name.toLowerCase(),
              fb = b.name.toLowerCase();
            if (fb < fa) {
              return -1;
            }
            if (fb > fa) {
              return 1;
            }
            return 0;
          }),
        ],
      };
    case "SEARCHED_Employee_Record":
      const filteredData = state.employeesData.slice().filter((emp) => {
        const allKeys = Object.keys(...state.employeesData);
        let val;
        for (let i = 0; i < allKeys.length; i++) {
          const rowWord = String(emp[allKeys[i]]);
          if (
            rowWord.toLowerCase().includes(action.payload.toLowerCase().trim())
          ) {
            val = true;
          }
        }

        return val;
      });
      console.log(filteredData);
      return {
        ...state,
        filteredEmployeeData: [...filteredData],
        keyword: true,
        searchedWord: action.payload,
      };
    case "FETCH_Employee_Record":
      return {
        ...state,
        keyword: false,
        filteredEmployeeData: [],
      };
    default:
      return state;
  }
};

export default taskReducer;
